import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/5gs410uu_Day-01-AM-001-1-scaled.jpg";

const HeroSection = () => {
  const { t, isRTL } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="home" className="relative h-[75vh] min-h-[500px] overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt={t("hero.title")} className="w-full h-full object-cover" />
        <div
          className={`absolute inset-0 ${
            isRTL
              ? "bg-gradient-to-l from-black/30 via-black/60 to-black/80"
              : "bg-gradient-to-r from-black/80 via-black/60 to-black/30"
          }`}
        />
      </div>

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 flex flex-col justify-end pb-40">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="mb-4">
            <span className="text-white/80 text-sm font-medium tracking-wider uppercase">
              {t("hero.tag")}
            </span>
            <div className="w-16 h-1 bg-[#E8792B] mt-2 rounded-full" />
          </div>

          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl mb-4"
            data-testid="hero-title"
          >
            {t("hero.title")}
          </h1>

          <p className="text-white/80 text-lg md:text-xl max-w-2xl">{t("hero.subtitle")}</p>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-8 h-8 text-white/60" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
